import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

export default function useDefaultSettings() {
  const { data, isLoading, error } = useSWR<any>(
    '/scheduling/settings',
    fetcher
  )

  return {
    defaultSettings: data,
    isLoading: isLoading || error,
    error,
  }
}
